import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { trackPixelEvent } from '../hooks/useMetaPixel';
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta de débito o crédito'
}];
export function FinalCta() {
  return <section className="w-full border-t border-ink-800 bg-ink-900 py-20" id="checkout" aria-labelledby="cierre" data-id="element-87" data-mp="1jasbgor24ng9">
      <div className="mx-auto w-full max-w-4xl px-4 text-center sm:px-6" data-id="element-88" data-mp="1t2ybmlrgqb6j">
        <h2 id="cierre" className="font-display text-3xl font-900 leading-tight text-white sm:text-[2.75rem]" data-id="element-89" data-mp="1t510v3ksk0a7">
          El sol ya está ahí. Gratis. Todos los días.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-slate-300" data-id="element-90" data-mp="2245z08sfxrlu">
          La única decisión que falta es si vas a aprovecharlo con información real o si vas a
          seguir regalándole ese dinero a tu compañía eléctrica otro mes más.
        </p>
        <p className="mx-auto mt-4 max-w-2xl font-display text-lg font-700 text-gold" data-id="element-91" data-mp="s3w30h8lpcpl">
          Más de 1.200 familias en España y Latinoamérica ya tomaron esa decisión. Hoy es tu turno.
        </p>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-92" data-mp="123537ru27nke">
          <Countdown label="El precio cierra en" data-id="element-93" data-mp="120se8upvwcxu" />
        </div>

        <div className="mt-8 flex justify-center" data-id="element-94" data-mp="163p0qwijot72">
          <a href="https://codigo-solar-360.impultienda.ar/checkout" onClick={() => trackPixelEvent('InitiateCheckout', {
          value: 17,
          currency: 'USD'
        })} className="rounded-xl bg-gold px-8 py-4 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:text-lg" data-id="element-95" data-mp="1b3jqgwql3cqj">
            QUIERO MI CÓDIGO SOLAR — $14 USD
          </a>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[13px] text-slate-400" data-id="element-96" data-mp="1tryj1ogjuytg">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1.5" data-id="element-97" data-mp="3lvkkvv0w8fub">
              <item.icon className="h-3.5 w-3.5 text-leaf-400" aria-hidden="true" data-id="element-98" data-mp="3lthomt95dqh5" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}